import React, { useState, useEffect } from "react";
import { Tag } from "lucide-react";

function Unit({ value, label }) {
  return (
    <div className="flex flex-col items-center">
      <div className="font-display text-4xl sm:text-5xl font-bold text-white bg-[#0a1424] border border-[rgba(46,155,255,0.25)] rounded-xl w-20 h-20 grid place-items-center">
        {String(value).padStart(2, "0")}
      </div>
      <span className="text-slate-400 text-xs mt-2 tracking-wide">{label}</span>
    </div>
  );
}

export default function Promo() {
  const [t, setT] = useState({ h: 47, m: 59, s: 59 });
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const id = setInterval(() => {
      setT((p) => {
        let { h, m, s } = p;
        if (s > 0) s--; else { s = 59; if (m > 0) m--; else { m = 59; if (h > 0) h--; } }
        return { h, m, s };
      });
    }, 1000);
    return () => clearInterval(id);
  }, []);

  const apply = () => { navigator.clipboard?.writeText("REALALGO50"); setCopied(true); setTimeout(() => setCopied(false), 1800); };

  return (
    <section className="py-20">
      <div className="max-w-4xl mx-auto px-5 lg:px-8">
        <div className="rounded-3xl p-10 text-center relative overflow-hidden" style={{ background: "linear-gradient(135deg,#0c1c34,#0a1120)", border: "1px solid rgba(46,155,255,0.3)" }}>
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(46,155,255,0.2),transparent_60%)]" />
          <div className="relative">
            <span className="inline-flex items-center gap-2 text-[12px] font-semibold text-[#9fd0ff] px-4 py-1.5 rounded-full bg-[rgba(46,155,255,0.1)] border border-[rgba(46,155,255,0.3)]">
              <Tag className="w-3.5 h-3.5" /> Limited Time Offer
            </span>
            <h2 className="font-display text-4xl lg:text-5xl font-bold text-white mt-5">Use Promo Code <span className="text-blue-grad">"REALALGO50"</span></h2>
            <p className="text-slate-300 mt-3">To get <span className="text-white font-semibold">20% OFF</span> the price NOW & enjoy monthly profit up to 40% today!</p>

            <div className="flex items-center justify-center gap-4 sm:gap-6 mt-8">
              <Unit value={t.h} label="Hours" />
              <span className="font-display text-4xl text-[#2e9bff] -mt-6">:</span>
              <Unit value={t.m} label="Mins" />
              <span className="font-display text-4xl text-[#2e9bff] -mt-6">:</span>
              <Unit value={t.s} label="Secs" />
            </div>

            <div className="flex items-center justify-center gap-3 mt-8">
              <div className="px-6 py-3 rounded-xl bg-[#0a1424] border border-dashed border-[rgba(46,155,255,0.4)] font-mono font-bold tracking-widest text-white">REALALGO50</div>
              <button onClick={apply} className="btn-primary px-6 py-3 rounded-xl font-semibold">{copied ? "Copied!" : "Apply"}</button>
            </div>
            <p className="text-slate-500 text-xs mt-6">* Offer valid for limited time only. Cannot be combined with other offers.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
